import React from 'react';
import styled from 'styled-components';

const NormalInputDivBlock = styled.div`
    height: ${props => props.height || '40px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-top: ${props => props.marginTop || '0px'};
    width: ${props => props.width || '100%'};
    position: relative;
`;

const NormalInputBlock = styled.input`
    height: 40px;
    width: 100%;
    padding: 0 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: ${props => props.fontSize || '14px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-top: ${props => props.marginTop || '0px'};
    
    &:focus {
        border: ${props => props.focusBorder};
        outline: 0
    }

    ::-webkit-input-placeholder {
        color: #ccc
    }

    ::-moz-placeholder {
        color: #ccc
    }
    
    ::-ms-input-placeholder {
        color: #ccc
    }

    ::placeholder {
        color: #ccc
    }
    :focus {
        outline: 0
    }

    text-align: ${props => props.textAlign || ''};
`;

const NormalInputSpanBlock = styled.span`
    display: ${props => props.dispError ? 'block' : 'none'};
    margin-top: ${props => props.errTop || '6px'};
    line-height: 20px;
    font-size: ${props => props.errFontSize || '12px'};
    color: #fc1c67;
    text-align: ${props => props.spanAlign || ''};
`;

const NormalInput = ({ type, maxLength, placeholder, marginBottom,
    marginTop, marginInnerTop, onBlur, onFoucs,
    onChange, dispError, errText, disabled, fontSize,
    errFontSize, errHeight = '70px', width, defaultValue = '', inputRef, enterPress, errTop, spanAlign, errIcon=false, textAlign='' }) => {

    let bMargin = dispError ? '0px' : marginBottom;
    let height = dispError ? errHeight : '40px';

    // Error 이지만 메시지가 없을 경우 처리 
    if (dispError && (errText === undefined || errText.maxLength === 0)) {
        bMargin = marginBottom;
        height = '40px';
    }

    var setting = {
        type: type,
        maxLength: maxLength,
        placeholder: placeholder,
        onChange: onChange,
        marginTop: marginInnerTop,
        focusBorder: dispError ? '1px solid #fc1c67' : '1px solid #ffc742',
        disabled: disabled,
        fontSize: fontSize,
        errFontSize: errFontSize,
        defaultValue: defaultValue,
        textAlign: textAlign
    }

    const handeBlur = () => {
        // console.log("handeBlur ++++++++");
        if (onBlur != null && onBlur !== undefined) {
            onBlur();
        }
    }

    const handleFocus = () => {
        // console.log("handleFocus ------>")
        if (onFoucs != null && onFoucs !== undefined) {
            onFoucs();
        }
    }
    //#2575 로그인 엔터키 처리 추가
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
           
            if (enterPress != null && enterPress !== undefined) {
                //console.log('enter press')
                enterPress();
            }
        }
    }
    
    return (
        <NormalInputDivBlock
            height={height}
            width={width}
            marginTop={marginTop}
            marginBottom={bMargin}>
            <NormalInputBlock  ref = {inputRef} 
                {...setting}
                onBlur={() => { handeBlur() }}
                onFocus={() => { handleFocus() }}
                onKeyDown={handleKeyDown}
                />
            <NormalInputSpanBlock dispError={dispError} errTop={errTop} errFontSize={errFontSize} spanAlign={spanAlign} className={errIcon ? "error-msg no-p" : ''}>
                {
                    (errText !== null  && typeof(errText) === "string" && errText.length > 0  && errText.indexOf("\n") > -1 ? errText.split("\n").map(function(item, idx) {
                        return (
                            <span key={idx}>
                                {item}
                                <br/>
                            </span>
                         )
                    }) : errText)
                }
                </NormalInputSpanBlock>
        </NormalInputDivBlock>
    );
};

export default NormalInput;